module.exports = __webpack_public_path__ + "static/media/qr-code.3eeb0598.svg";